import { EnvType } from "../services";
import ApiClient from "../api-client";
import IPlanningUserTaskApiClient from "./planning-user-task-api-client";
import PlanningUserTaskApiClient from "./planning-user-task-api-client";
import { CommentTaskRequest } from "../Types/comment-task-request";
import { DbOrderManualTaskServiceInfos } from "../Types/db-order-manual-task-service-infos";
import { DbOrderManualTaskTasksInfos } from "../Types/db-order-manual-task-tasks-infos";
import { DbOrderManualTaskTemplateInfos } from "../Types/db-order-manual-task-template-infos";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetManualTasksGroupedByServicesResponse } from "../Types/get-manual-tasks-grouped-by-services-response";
import { GetManualTasksTemplateByIdResponse } from "../Types/get-manual-tasks-template-by-id-response";
import { GetManualTasksTemplateWithComputedPricesRequest } from "../Types/get-manual-tasks-template-with-computed-prices-request";
import { GetManualTasksTemplatesResponse } from "../Types/get-manual-tasks-templates-response";
import { GetTaskResponse } from "../Types/get-task-response";
import { ListTaskResponse } from "../Types/list-task-response";
import { ManualTaskPlanningStatus } from "../Types/manual-task-planning-status";
import { UpdateTaskRequest } from "../Types/update-task-request";
import { GetGroupPlanningInfosResponse } from "../Types/get-group-planning-infos-response";
import { GetResourceListResponse } from "../Types/get-resource-list-response";
import { UpdateOrCreateResourceRequest } from "../Types/update-or-create-resource-request";
import { ManualTaskPlanningEventInfos } from "../Types/db-order-manual-task-planning-infos";
import { UpdateEventByTaskIdRequest } from "../Types/update-event-by-task-id-request";

export default class PlanningUserTaskService {
  planningUserTaskApiClient: IPlanningUserTaskApiClient;

  constructor(envType: EnvType) {
    this.planningUserTaskApiClient = new PlanningUserTaskApiClient(new ApiClient(envType), envType);
  }

  async GetManualTasksTasksGroupedByServices(): Promise<GetManualTasksGroupedByServicesResponse> {
    return await this.planningUserTaskApiClient.GetManualTasksTasksGroupedByServices();
  }
  async CreateManualTasksService(request: DbOrderManualTaskServiceInfos): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.CreateManualTasksService(request);
  }
  async UpdateManualTasksService(request: DbOrderManualTaskServiceInfos): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.UpdateManualTasksService(request);
  }
  async DeleteManualTasksService(id: number): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.DeleteManualTasksService(id);
  }
  async CreateManualTasksTask(request: DbOrderManualTaskTasksInfos): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.CreateManualTasksTask(request);
  }
  async UpdateManualTasksTask(request: DbOrderManualTaskTasksInfos): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.UpdateManualTasksTask(request);
  }
  async DeleteManualTasksTask(id: number): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.DeleteManualTasksTask(id);
  }
  async GetManualTasksTemplates(): Promise<GetManualTasksTemplatesResponse> {
    return await this.planningUserTaskApiClient.GetManualTasksTemplates();
  }
  async GetManualTasksTemplateById(id: number): Promise<GetManualTasksTemplateByIdResponse> {
    return await this.planningUserTaskApiClient.GetManualTasksTemplateById(id);
  }
  async GetManualTasksTemplateByIdWithComputedPrices(
    request: GetManualTasksTemplateWithComputedPricesRequest
  ): Promise<GetManualTasksTemplateByIdResponse> {
    return await this.planningUserTaskApiClient.GetManualTasksTemplateByIdWithComputedPrices(request);
  }
  async CreateManualTasksTemplate(request: DbOrderManualTaskTemplateInfos): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.CreateManualTasksTemplate(request);
  }
  async UpdateManualTasksTemplate(request: DbOrderManualTaskTemplateInfos): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.UpdateManualTasksTemplate(request);
  }
  async DeleteManualTasksTemplate(id: number): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.DeleteManualTasksTemplate(id);
  }
  async GetTaskById(id: number): Promise<GetTaskResponse> {
    return await this.planningUserTaskApiClient.GetTaskById(id);
  }
  async ClaimTaskById(id: number): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.ClaimTaskById(id);
  }
  async AssignTaskById(id: number, userId: number, dueDate: string): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.AssignTaskById(id, userId, dueDate);
  }
  async UnassignTaskById(id: number): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.UnassignTaskById(id);
  }
  async MoveTaskById(id: number, status: ManualTaskPlanningStatus): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.MoveTaskById(id, status);
  }
  async UpdateTaskById(request: UpdateTaskRequest): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.UpdateTaskById(request);
  }
  async UpdateEventByTaskId(
    taskId: number,
    eventGuid: string,
    request: UpdateEventByTaskIdRequest
  ): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.UpdateEventByTaskId(taskId, eventGuid, request);
  }
  async CommentTaskById(request: CommentTaskRequest): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.CommentTaskById(request);
  }
  async ListTasksByDateRange(startDateAsString: string, endDateAsString: string): Promise<ListTaskResponse> {
    return await this.planningUserTaskApiClient.ListTasksByDateRange(startDateAsString, endDateAsString);
  }
  async ListTasksByObjectId(objectId: number): Promise<ListTaskResponse> {
    return await this.planningUserTaskApiClient.ListTasksByObjectId(objectId);
  }
  async ListTasksByStatus(status: ManualTaskPlanningStatus): Promise<ListTaskResponse> {
    return await this.planningUserTaskApiClient.ListTasksByStatus(status);
  }
  async GetResourceList(): Promise<GetResourceListResponse> {
    return await this.planningUserTaskApiClient.GetResourceList();
  }
  async GetGroupPlanningInfos(): Promise<GetGroupPlanningInfosResponse> {
    return await this.planningUserTaskApiClient.GetGroupPlanningInfos();
  }
  async CreateResource(request: UpdateOrCreateResourceRequest): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.CreateResource(request);
  }
  async UpdateResource(objectId: number, request: UpdateOrCreateResourceRequest): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.UpdateResource(objectId, request);
  }
  async DeleteResource(objectId: number): Promise<GenericResponseStd> {
    return await this.planningUserTaskApiClient.DeleteResource(objectId);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.planningUserTaskApiClient.GetApiUrl();
  }
}
